import { ValidationOutcomes, ValidationResult } from '.';

const ValidateFlyingDaysComponentProps = (props: any): ValidationResult => {
  let vr: ValidationResult = {
    result: ValidationOutcomes.UNKNOWN,
    messages: [],
  };

  if (!props.locationTitle || typeof props.locationTitle !== 'string') {
    vr.result = ValidationOutcomes.FAILURE;
    vr.messages.push('Invalid or missing locationTitle.');
    return vr;
  }

  vr.result = ValidationOutcomes.SUCCESS;
  vr.componentProps = props;
  return vr;
};

export default ValidateFlyingDaysComponentProps;
